import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "@/theme/ThemeContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const OPTIONS = [
  { value: "light", label: "Light", icon: Sun },
  { value: "dark", label: "Dark", icon: Moon },
  { value: "system", label: "System", icon: Monitor },
];

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="theme-toggle-button"
        aria-label="Change theme"
        className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-card text-foreground transition-colors duration-300 hover:border-terracotta-500 hover:text-terracotta-500"
      >
        <Sun className="h-4 w-4 dark:hidden" />
        <Moon className="hidden h-4 w-4 dark:block" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="rounded-xl">
        {OPTIONS.map(({ value, label, icon: Icon }) => (
          <DropdownMenuItem
            key={value}
            data-testid={`theme-option-${value}`}
            onClick={() => setTheme(value)}
            className={`flex items-center gap-2 rounded-lg ${theme === value ? "text-terracotta-500" : ""}`}
          >
            <Icon className="h-4 w-4" />
            <span>{label}</span>
            {theme === value && <span className="ml-auto text-xs">Active</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
